export const emailTypes = ['Personal', 'Business', 'Other'];

export interface Email {
  type: string;
  emailAddress: string;
}
